import { IconDownload, IconTrash } from '@tabler/icons-react';
import { ActionIcon } from '@zorro/design-system/v2/ActionIcon';
import { Card } from '@zorro/design-system/v2/Card';
import { DocumentsIcon } from '@zorro/shared/assets';
import { Flex, Space, Text } from '@zorro/web/design-system';
import { downloadEmployerDocument } from '@zorro/web/ui-utils';

interface DownloadableDocumentProps {
  name: string;
  documentLocationUrl: string;
  onDelete?: () => void;
  canDelete: boolean;
  onDownload?: () => void;
}

const DownloadableDocument = ({
  name,
  documentLocationUrl,
  onDelete,
  canDelete,
  onDownload = async () => {
    await downloadEmployerDocument(documentLocationUrl, name);
  },
}: DownloadableDocumentProps) => {
  return (
    <Card key={name} variant="white-border">
      <Flex justify="space-between" align="center" w="100%">
        <Flex
          justify="space-evenly"
          align="center"
          style={{ overflow: 'hidden' }}
        >
          <DocumentsIcon />
          <Space w="md" />
          <Text mr="sm">{name}</Text>
        </Flex>
        <Flex align="flex-end">
          <ActionIcon size="md">
            <IconDownload onClick={onDownload} size={20} />
          </ActionIcon>
          <>
            <Space w="sm" />
            {canDelete && (
              <ActionIcon size="md">
                <IconTrash onClick={onDelete} size={20} />
              </ActionIcon>
            )}
          </>
        </Flex>
      </Flex>
    </Card>
  );
};

export { DownloadableDocument };
